export default __webpack_public_path__ + "static/media/img_ts_02_m.4270eb74.png";